import React from 'react'

export const YlmToggle = ({ item, clickToggle, color, bgColor, disabled = false }) => {
  const clasesToggle = [
    'ylm-toggle',
    item.active ? 'active' : '',
    disabled ? 'disabled' : '',
  ].filter(Boolean).join(' ');

  const pulsarToggle = () => {
    if (disabled) return;
    clickToggle( item._id );
  };

  return (
    <div
        className={ clasesToggle }
        onClick={ pulsarToggle }
        aria-disabled={ disabled }
    >
        <div
            className={ `toggle-bg`}
            style={{ backgroundColor: item.active ? bgColor : '#C9C5C5' }}
        >
            <span
                className={`toggle-item`}
                style={{ backgroundColor: item.active ? color : '#7B7B7B' }}
            ></span>
        </div>

        <p>{ item.text }</p>
    </div>
  )
}
